import { render, staticRenderFns } from "./StageCrudFields.vue?vue&type=template&id=040efd64"
import script from "./StageCrudFields.vue?vue&type=script&lang=js"
export * from "./StageCrudFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports